import { Toggle } from '@cinesend/ui-kit'
import { useState } from 'react'

const IsExternalApiValueSource = ({ field, saveField }) => {
  const [isExternalApiValueSource, setIsExternalApiValueSource] = useState(field.is_external_api_value_source)
  return (
    <Toggle
      pressed={isExternalApiValueSource}
      text='Get true value via External API'
      onToggle={() => {
        setIsExternalApiValueSource(!isExternalApiValueSource)
        saveField({ is_external_api_value_source: !isExternalApiValueSource })
      }}
    />
  )
}

export default IsExternalApiValueSource
